import { Alert, Modal } from "react-bootstrap";
import { Col, Row } from "./Grid";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { DefaultButton } from "./DefaultButton";
import Button from "./Button";
import Icon from "./Icon";

const ImageCaptureDialog = ({ onClose }) => {
    const { t } = useTranslation();
    const videoRef = useRef();
    const [error,setError] = useState();

    useEffect(() => {
        navigator.mediaDevices.getUserMedia({ video: true })
        .then(function (stream) {
            videoRef.current.srcObject = stream;
        }).catch(function (err) {
            if (err.name === 'NotAllowedError') {
                setError('You have not permitted Chronicler to access your webcam - please consult your browser documentation to enable camera support');
            } else if (err.name === 'NotFoundError') {
                setError('No devices were found from which to capture an image');
            } else {
                setError('An error occurred trying to acquire the camera video source (error details: ' + err.name + ' - ' + err.message + ')');
            }
        });
    }, [])

    const doCapture = () => {
        const canvas = document.createElement('canvas');
        canvas.style.display = 'none';
        canvas.width = videoRef.current.offsetWidth;
        canvas.height = videoRef.current.offsetHeight;
        document.body.appendChild(canvas);
        const ctx = canvas.getContext('2d');
        ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
        const dataURL = canvas.toDataURL('image/png');
        document.body.removeChild(canvas);
        doClose({ data: dataURL });
    }

    const doClose = (result) => {
        if (!error && videoRef.current?.srcObject) {
            const tracks = videoRef.current.srcObject.getTracks();
    
            tracks.forEach((track) => {
                track.stop();
            });
    
            videoRef.current.srcObject = null;
        }
        onClose(result);
    }

    return <Modal size="lg" show={true}>
        <Modal.Header>

        </Modal.Header>
        <Modal.Body style={{textAlign: 'center'}}>
            <Row>
                <Col>
                {error ? <Alert>{error}</Alert> : <video className="w-100" ref={videoRef} autoPlay></video>}
                </Col>
            </Row>
        </Modal.Body>
        <Modal.Footer>
            {error ? null : <Button variant="primary" onClick={doCapture}><Icon variant="solid" kind="camera"></Icon> {t('takeImage')}</Button> }
            <DefaultButton kind="close" onClick={() => doClose(null)}></DefaultButton>
        </Modal.Footer>
    </Modal>
}

export default ImageCaptureDialog;